module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }